export const iconFontAwesomeFilmVideoMicrophone = (
	<i className="fa-solid fa-microphone"></i>
);
